export const environment = {
  production: false,
  environmentKey: 'dev',
  appCd: 'maintenanceUI',
};
